







import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import DetailInfo from './DetailInfo.vue'
import AuditTimeline from './AuditTimeline.vue'

@Component({
  components: { DetailInfo, AuditTimeline }
})
export default class StepsSix extends Vue {
  @State applyStatus!: number
  auditInfo: any = undefined
}
